module.exports = __webpack_public_path__ + "img/icon-public-post.797ff3a3.png";